import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-create-manpower',
  templateUrl: './create-manpower.component.html',
  styleUrls: ['./create-manpower.component.css']
})
export class CreateManpowerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
